const NEW_LAYOUT_KEY = "use_new_layout"
const CHANGE_EVENT = "newLayoutPreferenceChanged"

const canUseBrowserStorage = () =>
  typeof window !== "undefined" && typeof window.sessionStorage !== "undefined"

const parseBoolean = (value) => value === "true"

/**
 * @function getNewLayoutPreference
 * @description Obtém a preferência de layout do usuário
 * @returns {boolean} true se o usuário está usando o novo layout, false caso contrário
 */
export const getNewLayoutPreference = () => {
  if (!canUseBrowserStorage()) {
    return false
  }

  const sessionValue = window.sessionStorage.getItem(NEW_LAYOUT_KEY)
  if (sessionValue !== null) {
    return parseBoolean(sessionValue)
  }

  // Backward compatibility: seed session value from legacy localStorage value.
  const legacyValue = window.localStorage.getItem(NEW_LAYOUT_KEY)
  if (legacyValue !== null) {
    const parsed = parseBoolean(legacyValue)
    window.sessionStorage.setItem(NEW_LAYOUT_KEY, String(parsed))
    return parsed
  }

  return false
}

/**
 * @function setNewLayoutPreference
 * @description Define a preferência de layout do usuário
 * @param {boolean} value - true se o usuário está usando o novo layout, false caso contrário
 */
export const setNewLayoutPreference = (value) => {
  if (!canUseBrowserStorage()) {
    return
  }

  const normalized = String(Boolean(value))
  window.sessionStorage.setItem(NEW_LAYOUT_KEY, normalized)
  window.dispatchEvent(new Event(CHANGE_EVENT))
}

/**
 * @function subscribeToNewLayoutPreference
 * @description Inscreve um listener para receber notificações de mudança de preferência de layout
 * @param {Function} listener - Função a ser chamada quando a preferência de layout mudar
 * @returns {Function} Função para desinscrever o listener
 */
export const subscribeToNewLayoutPreference = (listener) => {
  if (typeof window === "undefined") {
    return () => {}
  }

  window.addEventListener(CHANGE_EVENT, listener)
  return () => {
    window.removeEventListener(CHANGE_EVENT, listener)
  }
}
